import React, {Component, Fragment} from 'react';
import {firebaseActioner, auth} from '../firebase/firebase'
import trashIcon from './trashIcon.png';
import editIcon from './editIcon.png';
import EditorCV from './EditorCV.js';

import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom';



class AddNewProjectForm extends Component {
  constructor(props) {
      super(props);
      this.state = {value: ''};
  
      this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }
  
    handleChange(event) {
      this.setState({value: event.target.value});
    }
  
    handleSubmit(event) {
      createNewProjectFireStoreRQ(this.state.value);
      this.setState({value : ''})
      event.preventDefault();
    }
  
    render() {
      return (
          <div class="flex-fill d-flex justify-content-center align-items-start">
          <form onSubmit={this.handleSubmit}>
          <label>
            Add new project
            <input type="text" class="form-control" placeholder="project name" value={this.state.value} onChange={this.handleChange} />
          </label>
          <button class="btn btn-outline-success" type="submit" value="Submit" > Add </button>
        </form>
        </div>
      );
    }
}


function createNewProjectFireStoreRQ(topic)
{
  firebaseActioner.collection('Users').doc(auth.currentUser.uid).collection('projects').doc().set(
  { 
          createDate: Date.now(),
          projectName: topic,
          lastEditDate: Date.now(),
          project: []
  });
}

function deleteProject(DocumentId)
{
  firebaseActioner.collection('Users').doc(auth.currentUser.uid).collection('projects').doc(DocumentId).delete();
}

function ListOfProjects(props)
{
  const projectAttributes = props.list.map((dat) => 
  {
      return (<tr>
      <th scope="row">x</th>
      <td>{dat[0]}</td>
      <td>{dat[1]}</td>
      <td>{dat[2]}</td>
      <td>
      <Link to={`/dashboard/${dat[2]}`}><button type="button" class="btn btn-outline-success">
        <img className="img-fluid d-inline-block align-top" src={editIcon} width="25" height="25" alt=""></img>
        </button></Link>
      </td>
      <td>             
        <button type="button" class="btn btn-outline-success" onClick={deleteProject.bind(deleteProject, dat[2])}>
        <img className="img-fluid d-inline-block align-top" src={trashIcon} width="25" height="25" alt="" ></img>
        </button>
      </td>
      </tr>)
  });

  return (
    <div class="flex-fill d-flex justify-content-center align-items-start">
    <div>Your projects:

    <table class="table">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">Title</th>
      <th scope="col">Last update</th>
      <th scope="col">Created</th>
      <th scope="col">Edit</th>
      <th scope="col">Delete</th>

    </tr>
  </thead>
  <tbody>
    {projectAttributes}
  </tbody>
</table>
    </div>
   </div>
  )
}

class UserPanel extends Component {

  constructor(props)
  {
    super(props)
    this.state = {
      projectsList: [],
      logged: this.props.logged
    }
    this.currentDocumentEditedID = null
  }

componentDidMount()
{
  if(this.state.logged)
  firebaseActioner.collection('Users').doc(auth.currentUser.uid).collection('projects').onSnapshot(snapshot => {
    if (snapshot.docs.empty) {
      this.setState({projectsList : []});
        console.log('No such document!');
      } else {
        this.state.projectsList = [];
        snapshot.docs.forEach(el => {
           this.setState(prevState => ({
            projectsList: [...prevState.projectsList, [el.data().projectName, el.data().createDate, el.id]]
          }))
        })
      }
    }
    , function(error) {
      console.log("Fatal error: ", error);
  })
} 

render()
{
  let projetList = 
  () => <div class="d-flex h-100">
    <AddNewProjectForm/>
    <ListOfProjects list={this.state.projectsList}/>
  </div>
  if(this.state.logged === true)
  return (
    <Router>
    <Fragment>
      <Route exact path="/dashboard" component={projetList} />
      <Route path="/dashboard/:id" component={ 
        (props) => <EditorCV documentID={props.match.params.id} />
      } />
    </Fragment>
    </Router>
  );
  else
  return (<div>U are not logged</div>)
}
}


export default UserPanel